import React from 'react';
import c from 'classnames';
import Button, { ButtonProps } from '../../../../Button';
import ActionBarItemContentWrapper from '../ActionBarItemContentWrapper';
import s from './ActionBarB18Link.scss';

export type Props = {
  children?: React.ReactNode | undefined;
} & Omit<ButtonProps, 'view'>;

/**
 * Renders a view 'b18' Button. Also provides some ActionBar item styling.
 *
 * @deprecated We're moving away from the Button component
 */
const ActionBarB18Link: React.FC<Props> = ({ className, children, ...rest }) => (
  <Button view="b18" className={c(s['root'], className)} {...rest}>
    <ActionBarItemContentWrapper>{children}</ActionBarItemContentWrapper>
  </Button>
);
ActionBarB18Link.displayName = 'ActionBarB18Link';

export default ActionBarB18Link;
